// extracted by mini-css-extract-plugin
export default {"content":"EmployeeForm_content__h3lKL","row":"EmployeeForm_row__gW7JA","h1":"EmployeeForm_h1__pHnf6","inputs_wrapper":"EmployeeForm_inputs_wrapper__yFlMc"};